import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { WaiverRequestFilter } from 'src/app/shared/models/waiverrequestFilter.model';
import { WaiverRequestService } from 'src/app/shared/services/core/waiver-request.service';

@Component({
  selector: 'app-desistencia',
  imports: [TegelModule, CommonModule],
  templateUrl: './desistencia.component.html',
  styleUrl: './desistencia.component.scss'
})
export class DesistenciaComponent implements OnInit {
  request: any[];
  reactivates: any[];
  requestFilter: WaiverRequestFilter;
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";

  constructor(
    private dialogService: DialogService,
    private utilService: UtilService,
    private waiverRequestService: WaiverRequestService,
    private toastrService: ToastrService
  ) {
    this.requestFilter = new WaiverRequestFilter();
    this.reactivates = this.request = [];
  }

  ngOnInit(): void {}

  change(ev: any, val: any){
    if (ev.target.checked) {
      this.reactivates.push(val);
    } else {
      let i = this.reactivates.indexOf(val);
      this.reactivates.splice(i, 1);
    }
  }

  // openSaveClient(client = new Client()) {
  //   this.dialogService.addDialog(SaveClientComponent, {
  //     client: client
  //   }, this.utilService.getModalOptions()).subscribe((result) => {
  //       if(result && result.success){
  //         this.getClients(this.page);
  //         this.toastr.success('Registro salvo.', 'Sucesso');
  //       }
  //   });
  // }

  getAllWaiverRequest(page: number){
    this.reactivates = [];

    this.waiverRequestService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.requestFilter).subscribe((result) => {
      if (result) {
        this.request = result.page;
        this.page = result.currentPage;
        this.total = result.totalRecords;
      }
    });
  }

  reactivate() {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja reativar a(s) solicitação(ões) [ ' + this.reactivate.toString() + ' ] ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.sendReactivated();
      }
    });
  }

  sendReactivated() {
    this.waiverRequestService.reactivate(this.reactivates).subscribe((result) => {
      if (result && !result.hasErrors) {
        this.reactivates.forEach(id => {
          const index = this.request.findIndex(data => data.id === id);
          this.request.splice(index, 1);
        });

        this.reactivates = [];
        this.toastrService.success("Todas as requisições foram reativadas", "Sucesso");
      }
    });
  }

  resetFilters(form: NgForm){ 
    this.requestFilter = new WaiverRequestFilter();
    form.resetForm(this.requestFilter);
  }

  search() {
    this.getAllWaiverRequest(1);
  }

}
